import CarDto from './CarDto';
import ShopDto from './ShopDto';
import ServiceEntity, { ServiceStatus } from '../../domain/entities/ServiceEntity';

export class ServiceDto {
    static statusToString(status: ServiceStatus): string {
        const isRequested = localStorage.getItem(`requestedServiceId-${status}`);
        if (isRequested && status === ServiceStatus.Parked) {
            return 'waitingForAcceptance';
        }
        switch (status) {
            case ServiceStatus.WaitingForAcceptance:
                return 'waitingForAcceptance';
            case ServiceStatus.Parked:
                return 'parked';
            case ServiceStatus.DeliveriedStarted:
                return 'deliveredStarted';
            case ServiceStatus.OnWayToDeliver:
                return 'onWayToDeliver';
            case ServiceStatus.WaitingForPickup:
                return 'waitingForPickup';
            case ServiceStatus.Delivered:
                return 'delivered';
            default:
                return 'parked';
        }
    }

    static stringToStatus(status: string): ServiceStatus {
        switch (status) {
            case 'parked':
                return ServiceStatus.Parked;
            case 'deliveredStarted':
                return ServiceStatus.DeliveriedStarted;
            case 'onWayToDeliver':
                return ServiceStatus.OnWayToDeliver;
            case 'waitingForPickup':
                return ServiceStatus.WaitingForPickup;
            case 'delivered':
                return ServiceStatus.Delivered;
            case 'waitingForAcceptance':
                return ServiceStatus.WaitingForAcceptance;
            default:
                return ServiceStatus.Parked;
        }
    }

    static fromJson(json: any): ServiceEntity {
        return {
            id: json['qr_id']?.toString() || json['id']?.toString() || '',
            ownerGender: json['owner_genre'],
            car: CarDto.fromJson(json['vehicle']),
            qrId: json['qr_id']?.toString() || json['id']?.toString() || '',
            description: json['description'],
            serviceUpdateReason: json['service_update_reason'],
            photoKeyUrl: json['key_photo_url'],
            shop: ShopDto.fromJson(json['qr_code']?.['stablishment']),
            acceptedTyC: json['qr_code']?.['accept_terms'] === true,
            status: this.stringToStatus(json['service_status']),
        };
    }

    static toJson(service: ServiceEntity): any {
        return {
            id: service.id,
            owner_genre: service.ownerGender,
            vehicle: CarDto.toJson(service.car),
            qr_id: service.qrId,
            description: service.description,
            service_update_reason: service.serviceUpdateReason,
            key_photo: service.photoKeyUrl,
            service_status: this.statusToString(service.status),
        };
    }
}

export default ServiceDto;
